<template>
  <div class="report">
    <div v-for=" items in list">
      <div class="title">{{name}}</div>
      <div style="text-align: right">日期:{{time}}</div>
      <table>
        <tr>
          <th rowspan="2">车牌号</th>
          <th colspan="4">领取物品</th>
          <th colspan="4">下载物品</th>
          <th colspan="2">进出⼚时间</th>
          <th colspan="2">进出⼚公⾥数</th>
          <th rowspan="2">路线</th>
          <th rowspan="2">驾驶员</th>
          <th rowspan="2">押运员</th>
          <th rowspan="2">填表⼈(⻔卫)</th>
        </tr>
        <tr>
          <th>周转箱</th>
          <th>利器盒</th>
          <th>塑料袋</th>
          <th>领取时间</th>
          <th>感染性(箱)</th>
          <th>感染性(kg)</th>
          <th>损伤性(箱)</th>
          <th>损伤性(kg)</th>
          <th>出⼚</th>
          <th>进⼚</th>
          <th>出⼚</th>
          <th>进⼚</th>
        </tr>
        <tr v-for="item in items">
          <td >{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td >{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
          <td>{{item[8]}}</td>
          <td>{{item[9]}}</td>
          <td>{{item[10]}}</td>
          <td>{{item[11]}}</td>
          <td>{{item[12]}}</td>
          <td>{{item[13]}}</td>
          <td>{{item[14]}}</td>
          <td>{{item[15]}}</td>
          <td>{{item[16]}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Month",
    data(){
      return {
        name:"医疗废物清运⻋出⼊记录登记表",
        time:"2020-12-01",
        list:[
          [


          ],
        ]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
           this.list=res.list;
            this.name=res.name;
            this.time=res.date;
        } )
      },
    },
    mounted(){


    },
    created(){

      this.init()


    }
  }

</script>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:60px;line-height: 60px;font-weight: bold;font-size: 16px;}
  table{
    border-collapse: collapse;
    width: 100%;
  }
  table td{border: 1px solid #000;font-size: 12px;height: 35px;}
  table th{border: 1px solid #000;font-size: 12px;height:35px;}
</style>



// WEBPACK FOOTER //
// src/view/report/in-out.vue